/**
 *
 * @module adobeIdentityManagerConfiguration
 *
 */

import ServiceConfiguration from './serviceConfiguration';

/**
 *
 * @class AdobeIdentityManagerConfiguration
 * @desc Provides configuration information necessary for managing Adobe authentication.
 *
 */
export default class AdobeIdentityManagerConfiguration extends ServiceConfiguration {}



// WEBPACK FOOTER //
// ./src/services/configuration/adobeIdentityManagerConfiguration.js